import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
import { EventEmitter } from 'events';
import Log from './log';
/**
 * AudioProcessorEventObserver observes {@link AudioProcessor}
 * related operations and re-emits them as generic events.
 * @private
 */

export var AudioProcessorEventObserver = /*#__PURE__*/function (_EventEmitter) {
  _inherits(AudioProcessorEventObserver, _EventEmitter);

  var _super = _createSuper(AudioProcessorEventObserver);

  function AudioProcessorEventObserver() {
    var _this;

    _classCallCheck(this, AudioProcessorEventObserver);

    _this = _super.call(this);
    _this._log = new Log('AudioProcessorEventObserver');

    _this._log.info('Creating AudioProcessorEventObserver instance');

    _this.on('enabled', function () {
      return _this._reEmitEvent('enabled');
    });

    _this.on('add', function () {
      return _this._reEmitEvent('add');
    });

    _this.on('remove', function () {
      return _this._reEmitEvent('remove');
    });

    _this.on('create', function () {
      return _this._reEmitEvent('create-processed-stream');
    });

    _this.on('destroy', function () {
      return _this._reEmitEvent('destroy-processed-stream');
    });

    return _this;
  }

  _createClass(AudioProcessorEventObserver, [{
    key: "destroy",
    value: function destroy() {
      this.removeAllListeners();
    }
  }, {
    key: "_reEmitEvent",
    value: function _reEmitEvent(name) {
      this._log.info("AudioProcessor:".concat(name));

      this.emit('event', {
        name: name,
        group: 'audio-processor'
      });
    }
  }]);

  return AudioProcessorEventObserver;
}(EventEmitter);